<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row justify-content-center">
              <!-- <div class="col-lg-6 d-none d-lg-block"></div> -->
              <div class="col-lg-8 col-md-9 col-sm-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Online Learning системд нэвтэрнэ үү!</h1>
                    <h4>Оюутан нэвтрэх</h4>
                  </div>
                  <div class="user" autocomplete="off">
                    <hr />
                    <!-- <p style="color:red; font-weight:bold">Gmail ашиглаж шууд нэвтрэx</p>
                    <button v-if="loadingGoogle==false" @click="googleSignIn" type="button" class="btn btn-google btn-block">
                      <i class="fab fa-google fa-fw"></i> Login with Google
                    </button>
                    <button type="button" v-else class="btn btn-google btn-block" disabled>
                      <span class="spinner-border spinner-border-sm"></span>
                      Loading..
                    </button>
                    <br />
                    <hr /> -->
                    <div class="form-group" v-if="showUserName || showCode || showAddInfo">
                      <p style="color:#2653d4; font-weight:bold">Регистрийн болон оюутны кодоо баталгаажуулж системд нэвтэрнэ.</p>
                      <label for="exampleInputEmail1">Регистрийн дугаараа оруулна уу</label>
                      <input
                        autofocus
                        autocomplete="new-password"
                        v-model.trim="loginForm.register"
                        type="text"
                        class="form-control"
                        id="exampleInputEmail"
                        aria-describedby="emailHelp"
                        placeholder="Та регистрийн дугаараа оруулна уу"
                        v-on:keyup.enter="login"
                      />
                    </div>
                    <div class="form-group" v-show="showCode || showAddInfo">
                      <label for="exampleInputEmail1">Оюутны кодоо оруулна уу</label>
                      <input
                        :ref="'codeInput'"
                        autocomplete="new-password"
                        v-model.trim="loginForm.code"
                        type="password"
                        class="form-control"
                        id="exampleInputPassword"
                        placeholder="Та кодоо оруулна уу"
                        v-on:keyup.enter="login"
                      />
                    </div>
                    <!-- <div class="row" v-if="showAddInfo">
                      <div class="col form-group">
                        <input
                          v-model.trim="user.phone"
                          type="text"
                          class="form-control"
                          placeholder="Утасны дугаар"
                        />
                      </div>
                      <div class="col form-group">
                        <input
                          v-model.trim="user.email"
                          type="email"
                          class="form-control"
                          placeholder="Имэйл хаяг"
                        />
                      </div>
                    </div> -->

                    <div v-if="loading==false" @click="login" class="btn btn-primary btn-block">
                      <span>Нэвтрэх</span>
                    </div>
                    <button type="button" v-else class="btn btn-primary btn-block" disabled>
                      <span class="spinner-border spinner-border-sm"></span>
                      Loading..
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
        <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        register: "",
        code: ""
      },
      user: {
        email: null,
        phone: null
      },
      showUserName: true,
      showCode: false,
      showAddInfo: false,
      isTeacher: false,
      loadingGoogle:false,
      loading:false
    };
  },
  methods: {
    async login() {
      this.loading = true;
      if (this.showUserName == true) {
        if (
          this.loginForm != null &&
          this.loginForm.register != null &&
          this.loginForm.register != ""
        ) {

            var stsdata = await fb.db.collection("students").where("register", "==", this.loginForm.register.toLowerCase()).limit(1).get();
            this.loading=false;
            if (!stsdata.empty) {
              this.isTeacher = false;
              this.showUserName = false;
              this.showCode = true;
              this.$nextTick(() => {
                this.$refs['codeInput'].focus();
              });
              
            } 
            else {
              alert(
                "Таны регистрийн дугаар системд бүртгэлгүй байна . Та сургалтын албандаа хандана уу."
              );
            }
   
        } 
        else alert("Та регистрийн дугаарaa оруулна уу");
      } 
      else if (this.showCode == true) {
        
        if (
          this.loginForm != null &&
          this.loginForm.register != null &&
          this.loginForm.code != "" &&
          this.loginForm.code != null &&
          this.loginForm.code != ""
        ) {
          this.checkCode(this.loginForm.code.toLowerCase());
        } 
        else alert("Та кодоо оруулна уу");
      } 
      else if (this.showAddInfo == true) {
        if (
          this.loginForm != null &&
          this.loginForm.register != null &&
          this.loginForm.code != "" &&
          this.loginForm.code != null &&
          this.loginForm.code != "" &&
          this.user != null 
          // &&
          // this.user.phone != null &&
          // this.user.phone != "" &&
          // this.user.email != null &&
          // this.user.email != ""
        ) {
          if (this.isTeacher == true) {
            var datas = await fb.db
              .collection("teachers")
              .where("code", "==", this.loginForm.code.toLowerCase())
              .where("register", "==", this.loginForm.register.toLowerCase())
              .limit(1)
              .get();
            this.loading=false;
            if (!datas.empty) {
              var userObj = datas.docs[0];
              userObj.ref.update({
                email: this.user.email,
                phone: this.user.phone,
                createdAt: new Date()
              });
              this.createUserViaEmail(
                this.loginForm.register.toLowerCase() + "@muis.mn",
                this.loginForm.code.toLowerCase(),
                userObj
              );
            } 
            else {
              alert(
                "Таны регистрийн дугаар болон код зөрж байна . Та сургалтын албандаа хандана уу."
              );
            }
          } 
          else {
            var stsdata = await fb.db
              .collection("students")
              .where("code", "==", this.loginForm.code.toLowerCase())
              .where("register", "==", this.loginForm.register.toLowerCase())
              .limit(1)
              .get();
            
            if (!stsdata.empty) {
              var userObj = stsdata.docs[0];
              // userObj.ref.update({
              //   email: this.user.email,
              //   phone: this.user.phone,
              //   createdAt: new Date()
              // });
              this.createUserViaEmail(
                this.loginForm.register.toLowerCase() + "@muis.mn",
                this.loginForm.code.toLowerCase(),
                userObj
              );
              this.loading=false;
            }
            else{
                this.loading=false;
              alert(
                "Таны регистрийн дугаар болон код зөрж байна . Та сургалтын албандаа хандана уу."
              );
            }
          }
        } 
        else{
            this.loading=false;
            alert("Та утасны дугаар болон имэйл хаягаа оруулна уу");
        }
      }
    },
    async checkCode(code) {
        this.loading=true;
      if (code != null && code != null && code != "") {
        if (this.isTeacher == true) {
          var datas = await fb.db
            .collection("teachers")
            .where("code", "==", code)
            .where("register", "==", this.loginForm.register.toLowerCase())
            .limit(1)
            .get();
          if (!datas.empty) {
            var userObj = datas.docs[0];
            if (
              userObj != null &&
              userObj.exists &&
              userObj.data() != null &&
              userObj.data().user != null
            ) {
              this.loginViaEmail(
                this.loginForm.register.toLowerCase() + "@muis.mn",
                this.loginForm.code.toLowerCase()
              );
            } 
            else {
              this.showUserName = false;
              this.showCode = false;
              this.showAddInfo = true;
            }
            this.loading=false;
          } 
          else {
            this.loading=false;
            alert(
              "Таны регистрийн дугаар болон код зөрж байна . Та сургалтын албандаа хандана уу."
            );
          }
        } 
        else {
          var stsdata = await fb.db
            .collection("students")
            .where("code", "==", code)
            .where("register", "==", this.loginForm.register.toLowerCase())
            .limit(1)
            .get();
          if (!stsdata.empty) {
            var userObj = stsdata.docs[0];
            if (
              userObj != null &&
              userObj.exists &&
              userObj.data() != null &&
              userObj.data().user != null
            ) {
              this.loginViaEmail(
                this.loginForm.register.toLowerCase() + "@muis.mn",
                this.loginForm.code
              );
            } 
            else {
              this.showUserName = false;
              this.showCode = false;
              this.showAddInfo = true;
            }
            this.loading=false;
          } 
          else {
            this.loading=false;
            alert(
              "Таны регистрийн дугаар болон код зөрж байна. Та сургалтын албандаа хандана уу."
            );
          }
        }
      }
        else {
            this.loading=false;
            alert("Та регистрийн дугаарaa оруулна уу");
        }
    },
    loginViaEmail(email, password) {
      fb.auth
        .signInWithEmailAndPassword(email, password)
        .then(user => {
          fb.usersCollection
            .doc(user.user.uid)
            .get()
            .then(userData => {
              if (userData.exists) {
                if (
                  userData.data().verified == true
                ) {
                  this.$store.dispatch("setEnabledTrue");
                  this.$store.dispatch("fetchUserProfile");
                  this.performingRequest = false;
                  this.$router.push("/hello");
                } 
                else {
                  this.$store.dispatch("fetchUserProfile");
                  this.performingRequest = false;
                  this.$router.push("/addinfo");
                }
              } else {
                fb.usersCollection
                  .doc(user.user.uid)
                  .set({
                    email: user.email
                  })
                  .then(() => {
                    this.$store.dispatch("fetchUserProfile");
                    this.performingRequest = false;
                    this.$router.push("/addinfo");
                  })
                  .catch(err => {
                    console.log(err);
                    this.performingRequest = false;
                    this.errorMsg = err.message;
                  });
              }
            });
        })
        .catch(err => {
          console.log(err);
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    },
    createUserViaEmail(email, password, userObj) {
      console.log(email)
      fb.auth
        .createUserWithEmailAndPassword(email, password)
        .then(user => {
          this.$store.commit("setCurrentUser", user.user);
          if (this.isTeacher == true) {
            fb.usersCollection
              .doc(user.user.uid)
              .set({
                email: email,
                role: "teacher",
                customer: userObj.ref,
                verified: true,
                profileInfoAdded: true,
                code: this.loginForm.code,
                register: this.loginForm.register,
                createdAt: new Date()
              })
              .then(() => {
                userObj.ref.update({
                  user: fb.usersCollection.doc(user.user.uid)
                });
                this.$store.dispatch("fetchUserProfile");
                this.$store.dispatch("setEnabledTrue");
                this.performingRequest = false;
                this.$router.push("/hello");
              })
              .catch(err => {
                console.log(err);
              });
          } 
          else {
            fb.usersCollection
              .doc(user.user.uid)
              .set({
                email: email,
                role: "student",
                customer: userObj.ref,
                verified: true,
                profileInfoAdded: true,
                code: this.loginForm.code,
                register: this.loginForm.register,
                createdAt: new Date()
              })
              .then(() => {
                userObj.ref.update({
                  user: fb.usersCollection.doc(user.user.uid)
                });
                this.$store.dispatch("fetchUserProfile");
                this.$store.dispatch("setEnabledTrue");
                this.performingRequest = false;
                this.$router.push("/hello");
              })
              .catch(err => {
                console.log(err);
              });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    googleSignIn() {
        this.loadingGoogle=true;
      fb.auth
        .signInWithPopup(fb.googleProvider)
        .then(result => {
          var token = result.credential.accessToken;
          var user = result.user;

          this.$store.commit("setCurrentUser", user);

          fb.usersCollection
            .doc(user.uid)
            .get()
            .then(userData => {
                if (userData.exists) {
                  if(userData.data().role==null)
                    userData.ref.update({ provider: "google", role:"student" });
                    if (
                    userData.data().verified == true 
                    ) {
                        this.$store.dispatch("setEnabledTrue");
                        this.$store.dispatch("fetchUserProfile");
                        this.performingRequest = false;
                        this.$router.push("/hello");
                    } 
                    else {
                        this.$store.dispatch("fetchUserProfile");
                        this.$store.dispatch("setEnabledFalse");
                        this.performingRequest = false;
                        this.$router.push("/addinfo");
                    }
                }
                else {
                    fb.usersCollection
                    .doc(user.uid)
                    .set({
                        name: user.displayName,
                        email: user.email,
                        provider: "google",
                        role:"student" 
                    })
                    .then(() => {
                        this.$store.dispatch("fetchUserProfile");
                        this.performingRequest = false;
                        this.$store.dispatch("setEnabledFalse");
                        this.$router.push("/addinfo");
                    })
                    .catch(err => {
                        console.log(err);
                        this.performingRequest = false;
                        this.errorMsg = err.message;
                    });
                }
                this.loadingGoogle=false;
            });
        })
        .catch(function(error) {
            this.loadingGoogle=false;
          console.log(error);
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          this.$store.dispatch("setEnabledFalse");
          // ...
        });
    }
  }
};
</script>

